<template>
  <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
    <b-form-group :label="$t('patrol_logs.unit_commander.name')" label-for="name">
      <b-form-input
        id="name"
        v-model="formData.name"
        :placeholder="$t('patrol_logs.unit_commander.placeholder_name')"
        maxlength="255"
        trim
        required
      />
    </b-form-group>

    <b-form-group :label="$t('patrol_logs.unit_commander.telephone_number')" label-for="telephone_number">
      <b-form-input
        id="telephone_number"
        v-model="formData.telephone_number"
        :placeholder="$t('patrol_logs.unit_commander.placeholder_telephone')"
        maxlength="50"
        trim
      />
    </b-form-group>

    <div class="d-flex mt-2">
      <b-button variant="primary" class="mr-2" type="submit">
        {{ isAdd ? $t('actions.add') : $t('actions.update') }}
      </b-button>
      <b-button variant="outline-secondary" type="reset">
        {{ $t('actions.cancel') }}
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BButton } from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, { emit }) {
    const onSubmit = () => {
      emit('submit')
    }

    const onReset = () => {
      emit('reset')
    }

    return {
      onSubmit,
      onReset,
    }
  },
}
</script>
